import { render } from "./volume-mute.vue?vue&type=template&id=3fab2a72"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/volume-mute.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3fab2a72"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3fab2a72', __exports__)) {
    api.reload('3fab2a72', __exports__)
  }
  
  module.hot.accept("./volume-mute.vue?vue&type=template&id=3fab2a72", () => {
    api.rerender('3fab2a72', render)
  })

}


export default __exports__